import { render, staticRenderFns } from "./downloadcommon.vue?vue&type=template&id=ae573ffa&scoped=true&"
import script from "./downloadcommon.vue?vue&type=script&lang=js&"
export * from "./downloadcommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae573ffa",
  null
  
)

export default component.exports